import React from 'react';
import { Section } from '../Section';
import { RouteFlow } from '../RouteFlow';
import { TransformCTA } from '../TransformCTA';
const ROUTE = ['Finding', 'Assessment', 'Decision', 'Action', 'Monitoring', 'Follow-up / Referral'];
export function StopSearching() {
  return <Section tone="white" eyebrow="6 decision volumes + 5 premium bonuses" title={<>
          Stop searching.{' '}
          <span className="text-cyan-brand" data-id="element-258" data-mp="19w59jazmtcju">Start following the route.</span>
        </>} subtitle="Make renal decisions with a structured pathway beside you during the consultation." data-id="element-257" data-mp="1nouv5eb90fgf">
      <div className="mx-auto max-w-3xl space-y-5 text-[15.5px] leading-relaxed text-ink-soft sm:text-[17px]" data-id="element-259" data-mp="1014x49qd9ab8">
        <p data-id="element-260" data-mp="14ywql86nt4hj">
          Renal Decision Desk™ was designed around one simple problem: you
          don’t need another massive resource to read from beginning to end.
        </p>
        <p className="rounded-2xl border-l-4 border-cyan-brand bg-cyan-light px-5 py-4 font-display text-[19px] font-semibold italic leading-snug text-ink sm:text-2xl" data-id="element-261" data-mp="vwnfoh7hb93m">
          “I have THIS situation in front of me. What should I assess next?”
        </p>
        <p data-id="element-262" data-mp="1t67hzr2dez2b">
          Instead of opening multiple guidelines, searching through long
          documents, and trying to connect the information yourself, you start
          with the clinical scenario and follow the corresponding decision
          route.
        </p>
      </div>

      <p className="mt-9 text-center text-[11px] font-extrabold uppercase tracking-[0.18em] text-ink-soft" data-id="element-263" data-mp="10ffoj1cowoio">
        The system follows one simple structure
      </p>
      <div className="mt-4" data-id="element-264" data-mp="1a96cm54wmwxu">
        <RouteFlow steps={ROUTE} data-id="element-265" data-mp="1a9erg2kl8cbo" />
      </div>

      <TransformCTA label="Yes — I want the Renal Decision Desk™" sub="6 clinical volumes • 5 premium bonuses • 100% digital" data-id="element-266" data-mp="15fu02tdi2glg" />
    </Section>;
}